<template>
    <div>
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="订单编号" prop="orderNumber" style="width: 50%;">
                                <el-input v-model="q.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                            </el-form-item>
                          <el-form-item label="产品编码" >
                            <el-input v-model="q.materialCode" placeholder="请输入名称/编码" :clearable="true"></el-input>
                          </el-form-item>
                          <el-form-item label="产品大类">
                              <brselect category="product_level" :v="q.proModelCode" v-model="q.proModelCode" :clearable="true"
                                        style="width:100%"/>
                          </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <el-collapse-transition>
                                <div v-show="isScreen">
                                    <div class="h-thirdColumn w-newColumn">
                                        <el-form-item label="交货单创建时间" class="ddqlcpicker" style="width: 50%;">
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.dnCreateDateC"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                            <span class="w-time-to">至</span>
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.dnCreateDateD"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="到货日期" class="ddqlcpicker" style="width: 50%;">
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.deliveryDateC"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                            <span class="w-time-to">至</span>
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.deliveryDateD"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                    <div class="h-thirdColumn w-newColumn">
                                       <!-- <el-form-item label="签收日期" class="ddqlcpicker" style="width: 50%;">
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.acceptDateC"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                            <span class="w-time-to">至</span>
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="q.acceptDateD"
                                                    clearable
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                        </el-form-item>-->
                                        <el-form-item label="区域" prop="soldToAreaCode">
                                            <brselect clearable category="YLRegion" :v="q.soldToAreaCode"
                                                      v-model="q.soldToAreaCode"></brselect>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-collapse-transition>
                        </el-collapse-transition>
                      <div class="l-screenBox">
                          <div class="l-screen" @click="collapseChange">
                              <img :src="isScreen?closeScreen:drawScreen" alt="">
                              <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                          </div>
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
<!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"-->
<!--                                       @click="addEditDialog">新增-->
<!--                            </el-button>-->
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="sapCode"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="订单编号">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品型号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                width="90"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModelCode"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="大类编码">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="产地">
                        </el-table-column>
                        <el-table-column
                                prop="soldToAreaName"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="区域">
                        </el-table-column>
                        <el-table-column
                                prop="gscode"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="公司">
                        </el-table-column>
                        <el-table-column
                                prop="dnCreateDate"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="交货单创建日期">
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="到货日期">
                        </el-table-column>
                        <el-table-column
                                prop="otd"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="OTD天数">
                        </el-table-column>
                      <!--  <el-table-column
                                prop="acceptDate"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="签收日期">
                        </el-table-column>-->
                        <el-table-column
                                prop="agentName"
                                :show-overflow-tooltip="true"
                                width="200"
                                label="经销商名称">
                        </el-table-column>
                        <el-table-column
                                prop="agentCode"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="经销商编码">
                        </el-table-column>
                 <!--     <el-table-column
                              fixed="right"
                              label="操作"
                              style="width:10%">
                          <template slot-scope="scope">
                              <div class="w-caozuo" style="text-align: left;">
                                  <el-button
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn" @click="addEditDialog(scope.row,'edit')">
                                      修改
                                  </el-button>
                              </div>
                          </template>
                      </el-table-column>-->
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                       <!--     <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
                            </el-button>-->
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                        <!--    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>-->
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscProductControlExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    表格结束-->
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import supplierAreaService from "../../../api/dingd/supplierArea"

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                showdizhiflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                title:null,
                areaList:[],
                channelList:[],
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    materialCode:null,
                    oneLid:null,
                    acceptDate:null,
                    acceptDateC:null,
                    acceptDateD:null,
                    deliveryDateC:null,
                    deliveryDateD:null,
                    dnCreateDate:null,
                    dnCreateDateC:null,
                    dnCreateDateD:null,
                    proModelCode:null,
                    machineCode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                supplierList:[],
                userList:[],
                //弹窗
                dialogFormVisible: false,
                productNameArr: [],//弹窗中产品名称集合
                proudctLevelArr:[],
            }
        },
        created() {
            this.query();
        },
        methods: {
            // 展开折叠
            collapseChange() {
                this.isScreen = !this.isScreen;
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.materialCode = null;
                this.q.oneLid = null;
                this.q.acceptDate = null;
                this.q.dnCreateDate = null;
                this.q.machineCode = null;
                this.q.proModelCode = null;
            },
            query() {
                ss.OrderService.getOrderMianOtdList(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            },
            //新增
            changeUser(value){
                this.addEditFrom.dbrcode = value.usercode;
                this.addEditFrom.dbrname = value.username;
            },
            callFun(obj) {
                console.log(obj)
                let id = this.addEditFrom.oneLid;
                this.$set(this.addEditFrom, 'prodseries', obj.name); //产品大类名称
                this.$set(this.addEditFrom,'oneLid', obj.code);
                this.$set(this.addEditFrom,'materialName', null);
                this.$set(this.addEditFrom,'materialCode', null);
                id && this.selectProduct2Cg(id)
            },
            selectProduct2Cg(id) {
                ss.ProService.product2OemSelect(id).then(rd => {
                    this.productNameArr = rd;
                    this.proudctLevelArr = rd
                })
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.areaName = null;
                this.$refs[formName].resetFields();
            },
            //勾选事件
            handleSelectionChange(val) {
              this.multipleSelection = val;
              var sum = 0;
              this.multipleSelection.forEach(element => {
                element.syNum = element.availableNum - element.proNumber;
                sum += element.includeTaxAmount;
              });
              //进行强制数据渲染
              this.$forceUpdate();
            },
            //删除
            handleDelete(value) {
            },
            //修改
            update(value) {
              this.saveorupdate = 2;
                ss.supplierAreaService.selectById(value.id).then(rd => {
                    console.log(rd,"rdrdrdrdrdrdrd");
                    this.dialogFormVisible = true;
                    this.f = rd.obj;
                })
            },
            deleteSingle(id) {
              console.log("id", id)
              var data = id
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                ss.supplierAreaService.deleteList(data).then(res => {
                  console.log(res)
                  if (res.f == true) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.query()
                  } else {
                    this.$message.error(res.msg);
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/bscOrderMainOtd/downloadExcel", this.q, "get",);
            },
            //选择地址
            selectAreadialog() {
              this.showdizhiflag = true;
            },
            choseDizhi(obj) {
              console.log("obj",obj);
              this.f.areaName = obj.quobj.namepath;
              this.f.areaId = obj.quobj.code;
              this.showdizhiflag = false;
            },
            getSupplier(value){
                ss.supplierAreaService.selectByUserName(value).then(res => {
                  console.log(res)
                  this.supplierList = res.obj
                  this.f.supplierName = res.obj[0].username
                  this.f.supplierCode = res.obj[0].usercode
                })
            },
          freezeList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            console.log(this.multipleSelection);
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.freezeList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("冻结成功！")
                this.query();
              }
            });
          },
          thawList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.freezeUser = this.multipleSelection[i].freezeUser;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.thawList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("解冻成功！")
                this.query();
              }
            });
          },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
<!--弹窗样式开始-->
<style scoped>
    .commodityMaintenanceBox > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }

    /deep/ .el-dialog__header {
        padding: 0
    }

    /deep/ .el-dialog {
        border-radius: 0.1rem;
        width: 7.89rem;
    }

    /deep/ .el-dialog__body {
        padding: 0;
    }

    /deep/ .el-dialog__header {
        background: #2785E7
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
        height: 0.56rem;
        width: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background-color: #fff;
        color: #015ba0;
        border-radius: 100%;
        font-size: 0.34rem;
    }

    .h-dialogImg {
        height: 1.62rem;
        background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }

    .h-dialogImg h3 {
        text-align: left;
        padding: .6rem 0 0 0;
        font-size: 0.3rem;
        color: #fff;
        font-weight: normal;
        letter-spacing: 0.02rem;
    }

    .addDeliveryForm {
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .addDeliveryForm /deep/ .el-form-item{
        width: 48%;
        float: left;
    }
    .addDeliveryForm /deep/ .el-form-item__label {
        width: 84px;
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
        vertical-align: top;
        padding-right: 5px;
        letter-spacing: 0;
        display: inline-block;
        text-align: right;
    }
    .addDeliveryForm /deep/ .el-form-item__content {
        width: 67%
    }
    .addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
        border-radius: 0;
        background: transparent;
        color: #868686;
        border: 0;
        border-bottom: 1px solid #dedede;
        height: 0.29rem;
        line-height: 0.28rem;
        padding-left: 0.15rem;
    }

</style>
<!--弹窗样式结束-->